import { Component, Inject, OnInit } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { PaymentApiService } from "@api/payment/payment-api.service"
import { IconImageService } from "@shared/services/icon-image.service"
import { StateService } from "@shared/services/state.service"

@Component({
  selector: "ag-filter-dialog",
  standalone: false,
  templateUrl: "./ag-filter-dialog.component.html",
  styleUrl: "./ag-filter-dialog.component.scss",
})
export class AgFilterDialogComponent implements OnInit {
  filterData: filterData[] = []
  sortingData: sortingData[] = []
  currentSorting: sortingData
  sideDrawerShown: boolean = false
  madeChanges: boolean = false
  isMobile: boolean = false
  innerWidth: number = window.innerWidth
  isMaxFocused: boolean = false
  isMinFocused: boolean = false
  hotelCurrency: string = "DKK"

  constructor(public dialogRef: MatDialogRef<AgFilterDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public iconService: IconImageService, private stateService: StateService, private paymentService: PaymentApiService) {
    this.filterData = data.filterData
    this.sortingData = data.sortingData || []
    this.currentSorting = this.sortingData.some((sort) => sort.value) ? this.sortingData.find((sort) => sort.value) : this.sortingData[0]
    this.paymentService.getSite(this.stateService.selectedHotel.Id).subscribe((site) => {
      this.hotelCurrency = site?.MainCurrency || "DKK"
    })
  }
  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 575
    setTimeout(() => {
      this.sideDrawerShown = true
    }, 175)
  }

  closeSideDrawer() {
    this.sideDrawerShown = false
    setTimeout(() => {
      this.dialogRef.close({
        filterData: this.data.filterData,
        sortingData: this.data.sortingData,
      })
    }, 200)
  }
  applyFilter() {
    this.sideDrawerShown = false
    setTimeout(() => {
      this.dialogRef.close({
        filterData: this.filterData,
        sortingData: this.sortingData,
      })
    }, 200)
  }
  resetFilter() {
    this.filterData.forEach((filter) => {
      const defaultFilterLabel = filter.filter.find((item) => item.label === "default")?.imgPath ?? null
      filter.filter.forEach((item) => {
        if (!!defaultFilterLabel && defaultFilterLabel === item.label) item.value = true
        else item.value = false
      })
    })
    this.clearSorting()

    this.madeChanges = true
  }
  clearFilter(filter: filterData) {
    const defaultFilterLabel = filter.filter.find((item) => item.label === "default")?.imgPath ?? null
    filter.filter.forEach((item) => {
      if (!!defaultFilterLabel && defaultFilterLabel === item.label) item.value = true
      else item.value = false
    })
    if (filter.type === "spand") {
      filter.spandMin = null
      filter.spandMax = null
    }
    this.madeChanges = true
  }
  filterItem(filter: filterData, button: any) {
    if (filter.type !== "checkbox-multiple") {
      filter.filter.forEach((item) => {
        if (item.label === button.label) {
          item.value = !item.value
          this.madeChanges = true
        } else if (item.value) {
          item.value = false
        }
      })
    } else
      filter.filter.forEach((item) => {
        if (item.label === button.label) {
          item.value = !item.value
          this.madeChanges = true
        }
      })
  }

  selectAll(filter: filterData) {
    if (filter.type === "checkbox-multiple") {
      filter.filter.forEach((item) => {
        item.value = true
      })
      this.madeChanges = true
    }
  }

  resetAll(filter: filterData) {
    if (filter.type === "checkbox-multiple") {
      filter.filter.forEach((item) => {
        item.value = false
      })
      this.madeChanges = true
    }
  }
  applyDisabled(): boolean {
    if (!this.madeChanges) return true
  }
  clearAllDisabled(): boolean {
    return !this.filterData.some((filter) => filter.filter.some((item) => item.value)) && !this.sortingData.some((sort) => sort.value)
  }

  getFiltersWithoutDefault(filter: filterData): filterData {
    let newFitler: filterData = {
      title: filter.title,
      type: filter.type,
      filter: [],
    }
    filter.filter.forEach((filter) => {
      if (filter.label !== "default") {
        newFitler.filter.push(filter)
      }
    })
    return newFitler
  }

  sortDirection(event: string, sort: sortingData) {
    this.madeChanges = true

    this.sortingData.forEach((sortItem) => {
      if (sortItem.label === sort.label) {
        if (event === sortItem.ascendingLabel) {
          sortItem.currentSorting = "ascending"
        } else if (event === sortItem.descendingLabel) {
          sortItem.currentSorting = "descending"
        }
      }
    })
  }
  setSort(data: sortingData) {
    this.madeChanges = true
    this.sortingData.forEach((sort) => {
      if (sort.label === data.label) {
        sort.value = !sort.value
      } else {
        sort.value = false
      }
      if (sort.value) {
        this.currentSorting = sort
      }
    })
    if (!this.sortingData.some((sort) => sort.value)) {
      this.currentSorting = null
    }
  }
  clearSorting() {
    this.sortingData.forEach((sort) => {
      sort.value = false
      sort.currentSorting = "ascending"
      this.currentSorting = null
    })
  }
  getType(filter: filterData): string {
    if (filter.type === "checkbox-single" || filter.type === "checkbox-multiple") return "checkbox"
    else if (filter.type === "spand") return "spand"
    else return filter.type
  }
  spandInputMin(event: any, filter: filterData) {
    const value = Number((event.target as HTMLInputElement).value)

    filter.spandMin = value
  }

  spandInputMax(event: any, filter: filterData) {
    const value = Number((event.target as HTMLInputElement).value)
    filter.spandMax = value
  }

  public onFocus(input: string, filter: filterData) {
    if (input === "min") this.isMinFocused = true
    else this.isMaxFocused = true
  }

  public onBlur(input: string, filter: filterData) {
    if (input === "min") this.isMinFocused = false
    else this.isMaxFocused = false
  }
}

export interface filterData {
  title: string
  type: string
  filter: {
    label?: string
    imgPath?: string
    value?: boolean
  }[]
  spandMin?: number
  spandMax?: number
}
export interface sortingData {
  label: string
  value: boolean
  ascendingLabel: string
  descendingLabel: string
  currentSorting: string
}
